import { useEffect } from 'react';
import PropTypes from 'prop-types';

const suffix = 'Loyal UP';

const buildTitle = title => (title ? `${title} - ${suffix}` : suffix);

const WithTitle = ({ children, title }) => {
  useEffect(() => {
    if (title) document.title = buildTitle(title);
  }, [title]);
  return children;
};

WithTitle.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default WithTitle;
